<body>
  <div class="container-fluid h-100">
    <!--Toaster for success message-->
    <div class="toster success d-flex justify-content-end" *ngIf="showSuccess">
      <div class="toster-wrapper ps-3 d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center justify-content-between">
          <img width="20" src="/assets/ToasterIcons/tost-success.svg" />
          <div class="content ms-3">
            <h6 class="mb-0">Success</h6>
            <p style="font-weight: 600; cursor: pointer">{{ successMsg }}</p>
          </div>
        </div>
        <button class="btn" (click)="toastClose()">
          <img width="18" src="/assets/ToasterIcons/cross.svg" />
        </button>
      </div>
    </div>
    <!--Toaster for error message-->
    <div class="toster error d-flex justify-content-end" *ngIf="showError">
      <div class="toster-wrapper ps-3 d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center justify-content-between">
          <img width="20" src="/assets/ToasterIcons/tost-error.svg" />
          <div class="content ms-3">
            <h6 class="mb-0">Error</h6>
            <p style="font-weight: 600; cursor: pointer">{{ errorMsg }}</p>
          </div>
        </div>
        <button class="btn" (click)="toastClose()">
          <img width="18" src="/assets/ToasterIcons/cross.svg" />
        </button>
      </div>
    </div>
    <div class="toster success d-flex justify-content-end" *ngIf="showProcessing">
      <div class="toster-wrapper ps-3 d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center justify-content-between">
          <img width="20" src="../../../assets/icons/tost-error.svg" />
          <div class="content ms-3">
            <h6 class="mb-0">Wait</h6>
            <p>{{ processMsg }}</p>
          </div>
        </div>
        <button class="btn" (click)="toastClose()">
          <img width="18" src="../../../assets/icons/ic_close.svg" />
        </button>
      </div>
    </div>
    <router-outlet></router-outlet>
  </div>
</body>

<router-outlet></router-outlet>



<!-- <div *ngIf="router.url === '/app/dashboard'" class="chatbot-help mx-5">
  <div class="chatbot-box" (click)="toggleChatbot()">
    <div class="chatbot-icon">
      <div class="chatbot-circle">
        <img src="/assets/ToasterIcons/ai-12.png" alt="Chatbot" />
      </div>
      <div class="tooltip-msg">Need any help..??</div>
    </div>
  </div>
</div>


<iframe *ngIf="isChatbotVisible" src="http://localhost:4400/embed/chatbot/POS-AI/9622f67d-ede2-41df-a6d3-5ca587059299" width="600" height="700" style="
    border: none;
    position: fixed;
    bottom: 20px;
    right: 20px;
    z-index: 1000;
    border-radius: 12px;
    box-shadow: 0 4px 16px rgba(0,0,0,0.2);
  ">
</iframe> -->